import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('displayName'),
    validators.requiredString('email'),
    validators.validEmail('email'),
    validators.requiredString('mobile.value'),
    validators.requiredNumber('mobile.prefix'),
    validators.validPhone('mobile.value', 'mobile.prefix'),
    validators.requiredArray('userGroupIds'),
    validators.requiredArray('roleIds')
);

const useUserFormValidator = () => useValidator(validator);

export default useUserFormValidator;
